import { PortableTextBlock, stegaClean, toPlainText } from 'next-sanity';
import { jwtDecode } from 'jwt-decode';

function truncateText(text: string): string {
  const maxWords = 30;
  const maxChars = 175;

  const cleanText = stegaClean(text);
  const trimmedText = cleanText.trim();
  const words = trimmedText.split(/\s+/);
  let truncated = words.slice(0, maxWords).join(' ');
  if (truncated.length > maxChars) {
    truncated = truncated.slice(0, maxChars).trim();
  }
  if (truncated !== trimmedText) {
    truncated += '...';
  }
  return truncated;
}
export const summary = (content: PortableTextBlock[]) => {
  if (!content) {
    return '';
  }
  const plainText = toPlainText(content);
  const firstParagraph = plainText.split('\n\n')[0];
  return truncateText(firstParagraph);
  // return toPlainText(content).split('\n\n')[0];
};

export const formatDate = (date: string) => {
  return new Intl.DateTimeFormat('en-US', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(new Date(date as string));
};
export function convertDateFormat(dateString: string): string {
  // Create a Date object from the input string
  const date = new Date(dateString);

  // Define an array of month names
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  // Get the components of the date
  const year = date.getFullYear();
  const month = monthNames[date.getMonth()]; // Get month name
  const day = String(date.getDate()).padStart(2, '0'); // Pad day with leading zero

  // Format the date to "Month DD, YYYY"
  return `${month} ${day}, ${year}`;
}

export function schemaTypeAndPageMapping(schemaType: string) {
  switch (schemaType) {
    case 'blog':
      return {
        type: 'blog',
        page: 'blog',
      };
    case 'resource':
      return {
        type: 'resource',
        page: 'resources',
      };
    case 'faq':
      return {
        type: 'faq',
        page: 'support',
      };
    case 'news':
      return {
        type: 'news',
        page: 'news',
      };
    case 'caseStudy':
      return {
        type: 'caseStudy',
        page: 'case-studies',
      };
  }
}

interface DecodedToken {
  exp: number;
}

export const isTokenExpired = (token: string): boolean => {
  try {
    const decoded = jwtDecode<DecodedToken>(token);
    const currentTime = Math.floor(Date.now() / 1000);
    const bufferTime = 120; // 2 minutes buffer in seconds
    return decoded.exp <= currentTime + bufferTime;
  } catch {
    return true;
  }
};

// Helper function to extract domain from API URL
export const extractDomain = (apiUrl: string): string => {
  try {
    const url = new URL(apiUrl);
    return url.hostname.split('.').slice(-2).join('.'); // Gets "signupgenius.rocks"
  } catch {
    return 'signupgenius.com'; // Fallback
  }
};
